import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const PeriodTravelOrganicSolutions = () => {
  useMetaTags({
    title: "Best Organic Pads for Travel | Period Protection On-the-Go",
    description: "Stay comfortable and confident while traveling with organic period solutions. Discover travel-friendly, biodegradable, and compact pads for stress-free trips.",
    keywords: "organic pads for travel, travel period protection, biodegradable pads, compact period pads, eco-friendly sanitary pads, on-the-go menstrual care",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/period-travel-organic-solutions",
    ogTitle: "Best Organic Pads for Travel | Period Protection On-the-Go",
    ogDescription: "Travel worry-free with organic period pads that offer biodegradable, compact, and long-lasting protection for every journey.",
    ogImage: "https://images.unsplash.com/photo-1499363536502-87642509e31b?w=600",
    ogUrl: "https://organicpads.shop/period-travel-organic-solutions",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Best Organic Pads for Travel | Period Protection On-the-Go",
    twitterDescription: "Stay comfortable while traveling with biodegradable, compact organic period pads. Enjoy worry-free menstrual care anywhere you go.",
    twitterImage: "https://images.unsplash.com/photo-1499363536502-87642509e31b?w=600",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/period-travel-organic-solutions"
    },
    "headline": "Best Organic Pads for Travel | Period Protection On-the-Go",
    "description": "Stay comfortable and confident while traveling with organic period solutions. Discover travel-friendly, biodegradable, and compact pads for stress-free trips.",
    "image": "https://images.unsplash.com/photo-1499363536502-87642509e31b?w=600",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "organic pads for travel",
      "travel period protection",
      "biodegradable pads",
      "compact period pads",
      "eco-friendly sanitary pads",
      "on-the-go menstrual care"
    ]
  }
  

  return (
    <>
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-3xl font-bold text-center text-green-700">
        Traveling With Your Period: Organic Solutions for On-the-Go
      </h1>
      <img
        src="https://images.unsplash.com/photo-1499363536502-87642509e31b?w=600"
        alt="Period Travel"
        className="w-full my-4 rounded-lg"
      />
      <p>
        Managing your period while traveling doesn't have to be challenging.
        Organic pads offer reliable, portable protection that's perfect for
        travel while maintaining your commitment to health and sustainability.
      </p>
      
      <h2 className="text-2xl font-semibold mt-6">Travel-Friendly Benefits</h2>
      <ul className="list-disc list-inside mt-2 space-y-2">
        <li>Individually wrapped protection</li>
        <li>Biodegradable disposal</li>
        <li>Compact packaging</li>
        <li>Long-lasting freshness</li>
        <li>Secure protection</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mt-6">How to Travel Confidently?</h2>
      <p>
        Pack <strong>travel-sized</strong> organic pads and always carry extra
        protection for peace of mind.
      </p>
      
      <img
        src="https://plus.unsplash.com/premium-photo-1702598576513-fe7425ebf6bd?w=600"
        alt="Travel Care"
        className="w-full my-4 rounded-lg"
      />
      
      <h2 className="text-2xl font-semibold mt-6">Final Thoughts</h2>
      <p className="font-bold">
        Travel worry-free with reliable protection. <span className="text-green-700">Choose organic for adventures!</span>
      </p>
    </div>
    {/* Schema Markup */}
    <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default PeriodTravelOrganicSolutions;